
const ResultsSection = () => {
  const metrics = [
    {
      number: "500+",
      label: "Businesses Helped",
      description: "From startups to established brands across all industries"
    },
    {
      number: "$50M+",
      label: "Revenue Generated",
      description: "Total international revenue generated for our clients"
    },
    {
      number: "25+",
      label: "Countries Entered",
      description: "Markets successfully penetrated across all continents"
    },
    {
      number: "400%",
      label: "Average Growth",
      description: "Typical revenue increase within first year of expansion"
    },
    {
      number: "98%",
      label: "Success Rate",
      description: "Clients who achieve profitable international sales"
    },
    {
      number: "6 months",
      label: "Average Timeline",
      description: "From strategy to first international sale"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            The Numbers Speak for Themselves
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our track record demonstrates consistent success across industries, 
            markets, and business sizes. Here's what we've achieved together.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {metrics.map((metric, index) => (
            <div key={index} className="text-center p-8 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">{metric.number}</div>
              <div className="text-xl font-semibold text-gray-900 mb-3">{metric.label}</div>
              <div className="text-gray-600 leading-relaxed">{metric.description}</div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Become Our Next Success Story?
          </h3>
          <p className="text-lg text-gray-600 mb-8">
            Join the hundreds of businesses that have transformed their growth trajectory 
            through strategic international expansion.
          </p>
          <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Schedule Your Free Strategy Session
          </button>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
